import React from 'react';
import Button from '@material-ui/core/Button';
import theme from '../../theme';
import MenuItemAnchor from './MenuItemAnchor';

function isVisible() {
    return !Gaia.user.isAuthenticated;
}

function Toolbar(props) {
    if (!isVisible()) return null;

    return (<Button
        {...props}
        style={{
            ...props.style,
            color: theme.palette.primary.main
        }}
        color="primary"
        variant="outlined"
        href={`/login/?next=${window.location.pathname}`}
    >{gettext('Log In')}</Button>);
}

function HamburgerMenu(props) {
    if (!isVisible(props.user)) return null;

    return (<MenuItemAnchor {...props} href={`/login/?next=${window.location.pathname}`}>
        {gettext('Log In')}
    </MenuItemAnchor>);
}

export default { Toolbar, HamburgerMenu };
